import { queries } from "@/graphql";
import type { TypedDocumentNode } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { enqueueSnackbar } from "notistack";
import { useEffect } from "react";
import type { GgModulesType } from "@/types/graphql";

interface GetAllModulesResponse {
  modules?: Array<GgModulesType | null> | null;
  comModules?: Array<GgModulesType | null> | null;
}

/**
 * Custom hook to fetch the list of modules.
 * @param {object} [props] - The properties to be passed to the query.
 * @returns {{modulesList: GgModulesType[], loading: boolean, error?: any}} - The list of modules, loading state, and error.
 */
export function useModulesList(props: Record<string, any> = {}) {
  const variables = {
    ...props,
  };

  const { data, loading, error } = useQuery(
    queries.getAllModules as TypedDocumentNode<
      GetAllModulesResponse,
      Record<string, any>
    >,
    {
      variables,
      errorPolicy: "all",
    },
  );

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
  }, [error]);

  return {
    modulesList: (data?.modules || data?.comModules || [])
      .filter((module): module is GgModulesType => Boolean(module))
      .sort((a, b) => (a.name || "").localeCompare(b.name || "")),
    loading,
    error,
  };
}
